import { createFileRoute } from "@tanstack/react-router";
import { ArticlePage } from "@/components/ArticlePage";
import { articleSchemas } from "@/lib/seo";

const SITE = "https://shopify-freelancer.net";
const PATH = "/shopify-support";
const TITLE = "Shopify Support und Wartung: fester Ansprechpartner";
const DESCRIPTION =
  "Laufender Shopify Support: Fehler beheben, Anpassungen umsetzen, Theme pflegen. 110 € netto pro Stunde, Abrechnung nach tatsächlichem Aufwand, ohne Vertragsbindung.";

const faqs = [
  {
    q: "Was kostet laufender Shopify Support?",
    a: "110 € netto pro Stunde, abgerechnet nach tatsächlichem Aufwand. Es gibt keine Grundgebühr und keine Mindestlaufzeit.",
  },
  {
    q: "Wie schnell wird reagiert?",
    a: "Auf Anfragen antworte ich innerhalb von 48 Stunden. Kleinere Aufgaben sind meist innerhalb weniger Tage erledigt, bei einem Shop, der nicht mehr verkauft, gehe ich sofort ran, sobald ich davon weiß.",
  },
  {
    q: "Kann ich feste Stunden im Monat buchen?",
    a: "Ja, viele buchen ein paar Stunden im Monat für alles, was so aufläuft. Nicht genutzte Zeit wird nicht berechnet.",
  },
  {
    q: "Übernehmen Sie Shops von einem Vorgänger?",
    a: "Ja, das ist häufig der Fall. Ich sehe mir den vorhandenen Code an und sage Ihnen, ob Reparatur oder Neuaufbau der günstigere Weg ist.",
  },
  {
    q: "Wird im laufenden Shop gearbeitet?",
    a: "Nein. Gearbeitet wird in einer Kopie Ihres Themes oder in einem Testshop, veröffentlicht wird erst nach Ihrer Freigabe.",
  },
];

export const Route = createFileRoute("/shopify-support")({
  component: Page,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE}${PATH}` },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE}${PATH}` }],
    scripts: articleSchemas({ title: TITLE, description: DESCRIPTION, path: PATH, faqs }),
  }),
});

function Page() {
  return (
    <ArticlePage
      kicker="Support · Wartung"
      title="Shopify Support: jemand, der sich kümmert"
      intro="Ein Shop bleibt nie fertig. Es gibt Fehler nach Updates, Reste alter Apps, kleine Änderungen am Theme und Aufgaben, für die eine Agentur zu umständlich ist. Genau dafür bin ich buchbar."
      source="shopify-support"
      sections={[
        {
          h: "Typische Support-Aufgaben",
          p: [],
          list: [
            "Darstellungsfehler nach Theme- oder App-Updates",
            "Reste deinstallierter Apps, doppelte Skripte, kaputte Weiterleitungen",
            "Neue Sektionen, Texte, Banner, saisonale Anpassungen",
            "Versand-, Steuer- und Zahlungseinstellungen korrigieren",
            "Produktimporte und Datenpflege über die Shopify-Schnittstellen",
            "Ladezeit prüfen und unnötige Last entfernen",
          ],
        },
        {
          h: "Wie abgerechnet wird",
          p: [
            "110 € netto pro Stunde, nach tatsächlichem Aufwand. Vor größeren Aufgaben bekommen Sie eine Schätzung, bei umfangreicheren Umbauten einen Festpreis.",
            "Keine Grundgebühr, keine Mindestlaufzeit, keine Kündigungsfrist.",
          ],
        },
        {
          h: "So läuft eine Anfrage",
          p: [
            "Sie schreiben, was nicht stimmt, am besten mit Screenshot oder der betroffenen Adresse. Ich melde mich innerhalb von 48 Stunden mit Einschätzung und Aufwand, arbeite in einer Theme-Kopie und veröffentliche nach Ihrer Freigabe.",
          ],
        },
        {
          h: "Wenn der Shop steht",
          p: [
            "Bei einem Ausfall zählt Reihenfolge: erst den Verkauf wieder ermöglichen, dann die Ursache beheben. Schreiben Sie in dem Fall direkt, was zuletzt geändert wurde, das verkürzt die Suche erheblich.",
          ],
        },
        {
          h: "Was Sie behalten",
          p: [
            "Alle Änderungen liegen in Ihrem Shopify-Konto, nicht bei mir. Sie sind an keine Plattform und an keinen Dienstleister gebunden.",
          ],
        },
      ]}
      faqs={faqs}
      related={[
        { to: "/shopify-theme-anpassung", label: "Theme anpassen lassen" },
        { to: "/shopify-entwickler", label: "Shopify Entwickler buchen" },
        { to: "/kontakt", label: "Kontakt" },
      ]}
    />
  );
}
